import { Button } from 'app/components/common/Button';
import { Icon } from 'app/components/common/Icon';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import React from 'react';
import { useHistory, useLocation } from 'react-router';
import { BaseTreeStore, AgtBaseTreeStore } from 'app/stores/core/base.tree.store';
import { AllianzLogo } from 'app/containers/PrintDocumentContainer';
import { TreeNodeModel } from 'app/models/core/tree.node.model';
import { DownloadPdf } from './DownloadPdf';

export interface IBerichtePanelHeaderProps {
	panelAreaRef: React.MutableRefObject<HTMLDivElement | null>;
	treeStore: AgtBaseTreeStore | BaseTreeStore;
	title?: string;
	extras?: JSX.Element;
}

export const TreePanelHeader = observer((props: IBerichtePanelHeaderProps) => {
	const location = useLocation<any>();
	const treeStore = props.treeStore;

	const history = useHistory();
	const node = treeStore.menu.current;
	const nodeTitle = node ? node.name : '';
	const title = props.title ? props.title : nodeTitle;

	const prevBericht = () => {
		const node = treeStore.menu.findPreviousNode(treeStore.menu.current);
		if (!node) {
			return;
		}
		history.push(treeStore.getPath(node, location as any));
	};
	const nextBericht = () => {
		const node = treeStore.menu.findNextNode(treeStore.menu.current);
		if (!node) {
			return;
		}
		history.push(treeStore.getPath(node, location as any));
	};

	if (!node) return null;

	const pdfOpts = { ...props };
	if (node.downloadPdfOptions) {
		Object.assign(pdfOpts, node.downloadPdfOptions);
	}

	const downloadPdf = <DownloadPdf {...pdfOpts} />;

	return (
		<>
			<PrintHeader title={title} node={node} />
			<div className="panel-header">
				<div className="header-left">
					<div className="breadcrumb">
						{node &&
							node.parents &&
							node.parents.map((p) => (
								<span key={p.name}>
									{p.name} {'>'}{' '}
								</span>
							))}
					</div>
					<div className="subtitle is-4">{node && title}</div>
					{node.subTitle && <div className="subtitle is-5">{node.subTitle}</div>}
					<div className="details">
						{node.datenStand && (
							<span className="date">
								<strong>{node.datenStand}</strong>
							</span>
						)}{' '}
						{downloadPdf}
					</div>
				</div>
				<div className="header-right">
					<div className="button-group panel-nav">
						<Button className="button is-inverted panel-nav-button" onClick={prevBericht}>
							<Icon iconClass="chevron-left" />
						</Button>
						<Button className="button is-inverted panel-nav-button" onClick={nextBericht}>
							<Icon iconClass="chevron-right" />
						</Button>
					</div>
				</div>
				<div className="header-extras">
					<div className="extras">{props.extras && <>{props.extras}</>}</div>
				</div>
				{treeStore.showFilter && <div className="panel-filters">{node.filterComponent ? <>{node.filterComponent}</> : <>{treeStore.filterComponent}</>}</div>}
			</div>
		</>
	);
});

export interface IPrintHeader {
	title: string;
	node?: TreeNodeModel;
}
export const PrintHeader = observer((props: IPrintHeader) => {
	const { session, agenturUiStore } = useStore();
	const { title, node } = props;

	const user = session.currentUser;
	const agt = agenturUiStore.current;

	return (
		<div className="print-header">
			<div className="grid is-col-auto align-center">
				<div className="left pad-1rem title is-3">
					{node &&
						node.parents &&
						node.parents.map((p) => (
							<span key={p.name}>
								{p.name} {'>'}{' '}
							</span>
						))}
					{title}
				</div>
				<div className="text-right pad-1rem">
					<AllianzLogo />
				</div>
			</div>

			<div className="pad-bottom-1rem">
				<table className="table">
					<thead>
						<tr>
							<th>Erstellt durch</th>
							{agt && <th>Agentur</th>}
							{node && <th>Stand</th>}
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>{user?.name}</td>
							{agt && <td>{agt.name}</td>}
							{node && <td>{node.getDatenStand()}</td>}
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
});


